module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.service) ? _c('div', {
    staticClass: "service"
  }, [_c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  }), _vm._v(" "), (_vm.serviceObject.isMain) ? _c('div', {
    class: _vm.serviceObject.isMain ? 'page-header-wrapper' : '',
    style: (_vm.headerStyle)
  }, [_c('div', {
    staticClass: "page-header translucent-wrapper"
  }, [_c('div', {
    staticClass: "switch-wrapper"
  }, [_c('b-switch', {
    on: {
      "change": _vm.serviceChanged
    },
    model: {
      value: (_vm.serviceObject.isMain),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "isMain", $$v)
      },
      expression: "serviceObject.isMain"
    }
  }, [_vm._v("Основная услуга")]), _vm._v(" "), _c('span', {
    staticClass: "switch-caption"
  }, [_vm._v("Основные услуги отображаются блоком на главной")])], 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadServicePhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить фото")])]), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    on: {
      "change": _vm.handleUpdateService
    },
    model: {
      value: (_vm.serviceObject.title),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "title", $$v)
      },
      expression: "serviceObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    on: {
      "change": _vm.handleUpdateService
    },
    model: {
      value: (_vm.serviceObject.description),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "description", $$v)
      },
      expression: "serviceObject.description"
    }
  })], 1)], 1)]) : _c('div', {
    staticClass: "page-header secondary-service"
  }, [_c('div', {
    staticClass: "switch-wrapper"
  }, [_c('b-switch', {
    on: {
      "change": _vm.serviceChanged
    },
    model: {
      value: (_vm.serviceObject.isMain),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "isMain", $$v)
      },
      expression: "serviceObject.isMain"
    }
  }, [_vm._v("Основная улуга")])], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок"
    },
    model: {
      value: (_vm.serviceObject.title),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "title", $$v)
      },
      expression: "serviceObject.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    model: {
      value: (_vm.serviceObject.description),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "description", $$v)
      },
      expression: "serviceObject.description"
    }
  })], 1), _vm._v(" "), _c('Editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar,
      "placeholder": "Текст информации"
    },
    model: {
      value: (_vm.serviceObject.text),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "text", $$v)
      },
      expression: "serviceObject.text"
    }
  })], 1), _vm._v(" "), (_vm.serviceObject.isMain) ? _c('div', [_c('div', {
    staticClass: "service-description"
  }, [_c('h2', {
    staticClass: "has-text-centered"
  }, [_vm._v("Описание")]), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Текст",
      "type": "textarea"
    },
    on: {
      "change": _vm.handleUpdateService
    },
    model: {
      value: (_vm.serviceObject.additionalInfo),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "additionalInfo", $$v)
      },
      expression: "serviceObject.additionalInfo"
    }
  })], 1), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "advantages"
  }, [_c('draggable', {
    model: {
      value: (_vm.advantagesData),
      callback: function($$v) {
        _vm.advantagesData = $$v
      },
      expression: "advantagesData"
    }
  }, _vm._l((_vm.serviceObject.advantages), function(advantage) {
    return _c('Advantage', {
      key: advantage.id,
      attrs: {
        "advantage": advantage
      }
    })
  }), 1), _vm._v(" "), (_vm.serviceObject.advantages && _vm.serviceObject.advantages.length !== 4) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddAdvantage
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить преимущество\n        ")])]) : _vm._e()], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "extra-advantages logical-block-content"
  }, [_c('div', {
    staticClass: "description-wrapper"
  }, [_c('b-field', [_c('b-input', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Заголовок для экстра-преимуществ"
    },
    model: {
      value: (_vm.serviceObject.extraAdvantagesTitle),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "extraAdvantagesTitle", $$v)
      },
      expression: "serviceObject.extraAdvantagesTitle"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.serviceObject.extraAdvantages), function(advantage) {
    return _c('ExtraAdvantage', {
      key: advantage.id,
      staticClass: "extra-advantage-item",
      attrs: {
        "advantage": advantage
      }
    })
  }), _vm._v(" "), (_vm.serviceObject.extraAdvantages && _vm.serviceObject.extraAdvantages.length !== 6) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddExtraAdvantage
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить экстра-преимущество\n        ")])]) : _vm._e()], 2), _vm._v(" "), _c('div', {
    staticClass: "calculator-option"
  }, [_c('div', {
    staticClass: "switch-wrapper"
  }, [_c('b-switch', {
    model: {
      value: (_vm.serviceObject.showCalculator),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "showCalculator", $$v)
      },
      expression: "serviceObject.showCalculator"
    }
  }, [_vm._v("Показывать калькулятор")])], 1)]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "principles"
  }, [_c('draggable', {
    staticClass: "is-clearfix",
    model: {
      value: (_vm.principlesData),
      callback: function($$v) {
        _vm.principlesData = $$v
      },
      expression: "principlesData"
    }
  }, _vm._l((_vm.serviceObject.principles), function(principle) {
    return _c('Principle', {
      key: principle.id,
      attrs: {
        "principle": principle
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddPrinciple
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить новый принцип работы")])])], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "promo-wrapper is-flex"
  }, [_c('el-select', {
    staticClass: "promo-option",
    attrs: {
      "placeholder": "Выбрать акцию",
      "clearable": ""
    },
    on: {
      "change": _vm.changePromo
    },
    model: {
      value: (_vm.selectedPromo),
      callback: function($$v) {
        _vm.selectedPromo = $$v
      },
      expression: "selectedPromo"
    }
  }, _vm._l((_vm.servicePromos), function(promo) {
    return _c('el-option', {
      key: promo.id,
      attrs: {
        "label": promo.title,
        "value": promo.id
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "learn-more"
  }, [_c('b-field', {
    staticClass: "learn-more-field"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок",
      "required": ""
    },
    model: {
      value: (_vm.serviceObject.learnMoreButton.title),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject.learnMoreButton, "title", $$v)
      },
      expression: "serviceObject.learnMoreButton.title"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Ссылка",
      "required": ""
    },
    model: {
      value: (_vm.serviceObject.learnMoreButton.url),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject.learnMoreButton, "url", $$v)
      },
      expression: "serviceObject.learnMoreButton.url"
    }
  })], 1)], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "promo-wrapper is-flex"
  }, [_c('el-select', {
    staticClass: "promo-option",
    attrs: {
      "placeholder": "Выбрать услугу",
      "clearable": ""
    },
    on: {
      "change": _vm.changeAdditionalService
    },
    model: {
      value: (_vm.selectedService),
      callback: function($$v) {
        _vm.selectedService = $$v
      },
      expression: "selectedService"
    }
  }, _vm._l((_vm.additionalServices), function(service) {
    return _c('el-option', {
      key: service.id,
      attrs: {
        "label": service.title,
        "value": service.id
      }
    })
  }), 1)], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "rates-wrapper"
  }, [_c('draggable', {
    staticClass: "is-clearfix",
    model: {
      value: (_vm.ratesData),
      callback: function($$v) {
        _vm.ratesData = $$v
      },
      expression: "ratesData"
    }
  }, _vm._l((_vm.serviceObject.rates), function(rate) {
    return _c('Rate', {
      key: rate.id,
      attrs: {
        "rate": rate
      }
    })
  }), 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddRate
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить тариф")])]), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [(!_vm.serviceObject.ratesComparisonFile) ? _c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleloadDocument
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить документ сравнения тарифов")]) : _c('span', {
    staticClass: "rates-file"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": '/' + _vm.serviceObject.ratesComparisonFile
    }
  }, [_vm._v("Просмотреть документ сравнения тарифов")]), _vm._v(" "), _c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.deleteRatesComparisonFile
    }
  })]), _vm._v(" "), _c('input', {
    ref: "loadDocumentButton",
    attrs: {
      "type": "file",
      "hidden": ""
    },
    on: {
      "change": _vm.loadDocument
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "promo-wrapper is-flex"
  }, [_c('el-select', {
    staticClass: "p-option",
    attrs: {
      "placeholder": "Выбрать документ тарифов",
      "clearable": ""
    },
    on: {
      "change": _vm.changeRatesDocument
    },
    model: {
      value: (_vm.selectedRatesDocument),
      callback: function($$v) {
        _vm.selectedRatesDocument = $$v
      },
      expression: "selectedRatesDocument"
    }
  }, _vm._l((_vm.newDocumentsData), function(document) {
    return _c('el-option', {
      key: [document.path, document.resource_id].join('###'),
      attrs: {
        "label": ("" + (document.display_name)),
        "value": [document.path, document.resource_id].join('###')
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "reviews"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleAddReview
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить отзыв")])]), _vm._v(" "), (_vm.serviceObject.reviews && _vm.serviceObject.reviews.length) ? _c('swiper', {
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.serviceObject.reviews), function(review) {
    return _c('swiper-slide', {
      key: review.id
    }, [_c('Review', {
      attrs: {
        "review": review
      }
    })], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  })], 2) : _vm._e()], 1), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Номер индекса"
    },
    on: {
      "change": _vm.handleUpdateService
    },
    model: {
      value: (_vm.serviceObject.indexNumber),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "indexNumber", $$v)
      },
      expression: "serviceObject.indexNumber"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Как стать клиентом")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, _vm._l((_vm.serviceObject.becomeClientData), function(becomeClientData) {
    return _c('BecomeClient', {
      key: becomeClientData.id,
      attrs: {
        "becomeClientData": becomeClientData
      }
    })
  }), 1), _vm._v(" "), (_vm.serviceObject.becomeClientData && _vm.serviceObject.becomeClientData.length < 3) ? _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": function($event) {
        return _vm.addBecomeClientData()
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Добавить блок")])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "save-content-button centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveService()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column delete-service is-one-third",
    on: {
      "click": _vm.deleteService
    }
  }, [_c('span', [_vm._v("Удалить")])]), _vm._v(" "), _c('div', {
    staticClass: "column hide"
  }, [_c('b-switch', {
    on: {
      "input": function($event) {
        return _vm.setServiceGroup()
      }
    },
    model: {
      value: (_vm.serviceObject.isHidden),
      callback: function($$v) {
        _vm.$set(_vm.serviceObject, "isHidden", $$v)
      },
      expression: "serviceObject.isHidden"
    }
  }, [_vm._v("\n        Скрыть услугу с сайта\n      ")])], 1)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Преимущества услуги")]), _vm._v(" "), _c('span', [_vm._v("Максимум 4 блока с преимуществами")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Экстра-преимущества услуги")]), _vm._v(" "), _c('span', [_vm._v("Максимум 6 блоков с экстра-преимуществами")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Принципы работы")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Акция, соответствующая услуге")]), _vm._v(" "), _c('span', [_vm._v("Чтобы добавить акцию перейдите в меню \"Акции\"")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Узнать подробнее")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Сопутствующая услуга")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Тарифы")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Отзыв или успешная история")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "caption"
  }, [_c('h2', [_vm._v("Порядковый номер в списке")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dc1c626"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/Service.vue
// module id = 962
// module chunks = 0